var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgInsights = function SvgInsights(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "url(#Insights_svg__Insights_svg__paint0_linear_1596_339827)",
    fillOpacity: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "url(#Insights_svg__Insights_svg__paint1_linear_1596_339827)",
    strokeOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.235 17.647a1.882 1.882 0 011.883 1.883A1.882 1.882 0 0119 17.646a1.882 1.882 0 01-1.882-1.882 1.882 1.882 0 01-1.883 1.882zm0-11.294a1.882 1.882 0 011.883 1.882A1.882 1.882 0 0119 6.353a1.882 1.882 0 01-1.882-1.882 1.882 1.882 0 01-1.883 1.882zm-4.588 11.294A5.647 5.647 0 0116.294 12a5.647 5.647 0 01-5.647-5.647A5.647 5.647 0 015 12a5.647 5.647 0 015.647 5.647z",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Insights_svg__Insights_svg__paint0_linear_1596_339827",
    x1: 0,
    y1: 0.451,
    x2: 31.666,
    y2: 29.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#994DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25C0E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Insights_svg__Insights_svg__paint1_linear_1596_339827",
    x1: 0,
    y1: 0.451,
    x2: 30.662,
    y2: 27.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7930D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100"
  })))));
};
export default SvgInsights;